import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { apiFetch } from "../../api/client";
import { COLORS, RADIUS } from "../../theme";
import Card from "../../components/ui/Card";
import Btn from "../../components/ui/Btn";
import Input from "../../components/ui/Input";
import DoisFatores from "../../components/DoisFatores";

export default function AdminMeusDados() {
  const { token, usuario } = useAuth();
  const [senhaAtual, setSenhaAtual] = useState("");
  const [senhaNova, setSenhaNova] = useState("");
  const [senhaConfirma, setSenhaConfirma] = useState("");
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [salvando, setSalvando] = useState(false);

  const trocarSenha = async () => {
    setErro("");
    setSucesso("");
    if (senhaNova !== senhaConfirma) {
      setErro("A confirmação não bate com a nova senha.");
      return;
    }
    setSalvando(true);
    try {
      await apiFetch("POST", "/api/auth/trocar-minha-senha", { senha_atual: senhaAtual, senha_nova: senhaNova }, token);
      setSenhaAtual("");
      setSenhaNova("");
      setSenhaConfirma("");
      setSucesso("Senha alterada com sucesso.");
    } catch (e) {
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: COLORS.text, margin: "0 0 4px", letterSpacing: "-0.02em" }}>
          Meus Dados
        </h1>
        <p style={{ fontSize: 13.5, color: COLORS.textMid, margin: 0 }}>
          Login: <strong style={{ color: COLORS.textMid }}>{usuario?.nome}</strong>
        </p>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 16, maxWidth: 480 }}>
        <Card>
          <h2 style={{ fontSize: 15, fontWeight: 800, color: COLORS.text, margin: "0 0 16px" }}>Trocar senha</h2>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <Input label="Senha atual" type="password" value={senhaAtual} onChange={(e) => setSenhaAtual(e.target.value)} placeholder="••••••••" />
            <Input label="Nova senha" type="password" value={senhaNova} onChange={(e) => setSenhaNova(e.target.value)} placeholder="mínimo 6 caracteres" />
            <Input label="Confirmar nova senha" type="password" value={senhaConfirma} onChange={(e) => setSenhaConfirma(e.target.value)} placeholder="repita a nova senha" />
            {erro && (
              <div style={{ color: COLORS.danger, fontSize: 13, background: COLORS.dangerBg, border: "1px solid #FECACA", borderRadius: RADIUS.sm, padding: "9px 13px" }}>
                {erro}
              </div>
            )}
            {sucesso && (
              <div style={{ color: COLORS.success, fontSize: 13, background: COLORS.successBg, border: "1px solid #BBF7D0", borderRadius: RADIUS.sm, padding: "9px 13px" }}>
                {sucesso}
              </div>
            )}
            <Btn onClick={trocarSenha} disabled={salvando || !senhaAtual || !senhaNova || !senhaConfirma} style={{ alignSelf: "flex-start" }}>
              {salvando ? "Salvando..." : "Trocar senha"}
            </Btn>
          </div>
        </Card>

        <DoisFatores />
      </div>
    </div>
  );
}
